
import {UIGameInventorHighlightDiceController} from '../../../../shared/scripts/ui_game/ui_game_map/UIGameInventorHighlightDiceController'
import {CardPopupInformation} from '@colonist/game-card-types'
import {UIGamePopupCardConfirmation} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupCardConfirmation'
import {UIWGamePopupCardConfirmation} from '../ui_game_popup/UIWGamePopupCardConfirmation'

export class UIWGameInventorHighlightDiceController extends UIGameInventorHighlightDiceController {
    protected createInventorPopup(cardConfirmationPopupFormat: CardPopupInformation): UIGamePopupCardConfirmation {
        return new UIWGamePopupCardConfirmation(this.uiGameManager, cardConfirmationPopupFormat)
    }
}
